// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://netdna.bootstrapcdn.com/font-awesome/4.0.3/css/font-awesome.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circular-menu {
  margin: 0 auto;
  position: absolute;
  z-index: 12;
}
.circle {
  position: relative;
  width: 150px;
  height: 150px;
  opacity: 0;
  top: -45px;
  left: -45px;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  transform: scale(0);
  -webkit-transition: all 0.4s ease-out;
  -moz-transition: all 0.4s ease-out;
  transition: all 0.4s ease-out;
}
.open.circle {
  opacity: 1;
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  transform: scale(1);
}
.circle .icon {
  text-decoration: none;
  display: block;
  position: absolute;
  text-align: center;
  cursor: pointer;
  background-color: white;
  transition: 0.3s;
}
.circle a:hover {
  color: #eef;
}
.menu-button {
  position: absolute;
  top: 12px;
  left: 12px;
  text-decoration: none;
  text-align: center;
  color: #444;
  border-radius: 50%;
  display: block;
  height: 60px;
  width: 60px;
  line-height: 50px;
  padding: 10px;
  background: white;
  transition: 0.3s;
}
.menu-button:hover {
  background-color: #70B1B1;
}
.edit:hover {
  background-color: #71A647;
}
.questionMask:hover {
  background-color: #747CBE;
}
.topButton {
  color: black;
  font-size: 14px;
  font-weight: 500;
  width: 120px;
  height: 32px;
  border-radius: 8px;
  background-color: #f3f4f5;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
}
.active {
  color: white;
}
.tutorialButtonActive {
  background-color: #007500;
}
.otherButtonActive {
  background-color: #0076FF;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/CircleMenu/index.less"],"names":[],"mappings":"AAGA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AADF;AAIA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EAEA,2BAAA;EACA,wBAAA;EACA,mBAAA;EAEA,qCAAA;EACA,kCAAA;EACA,6BAAA;AAJF;AAOA;EACE,UAAA;EAEA,2BAAA;EACA,wBAAA;EACA,mBAAA;AANF;AASA;EACE,qBAAA;EACA,cAAA;EAGA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AATF;AAYA;EACE,WAAA;AAVF;AAaA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AAXF;AAcA;EACE,yBAAA;AAZF;AAgBE;EACE,yBAAA;AAdJ;AAmBE;EACE,yBAAA;AAjBJ;AAqBA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAnBF;AAsBA;EACE,YAAA;AApBF;AAuBA;EACE,yBAAA;AArBF;AAwBA;EACE,yBAAA;AAtBF","sourcesContent":["@import \"https://netdna.bootstrapcdn.com/font-awesome/4.0.3/css/font-awesome.css\";\n@import \"src/style/common.less\";\n\n.circular-menu {\n  margin: 0 auto;\n  position: absolute;\n  z-index: 12;\n}\n\n.circle {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  opacity: 0;\n  top: -45px;\n  left: -45px;\n\n  -webkit-transform: scale(0);\n  -moz-transform: scale(0);\n  transform: scale(0);\n\n  -webkit-transition: all 0.4s ease-out;\n  -moz-transition: all 0.4s ease-out;\n  transition: all 0.4s ease-out;\n}\n\n.open.circle {\n  opacity: 1;\n\n  -webkit-transform: scale(1);\n  -moz-transform: scale(1);\n  transform: scale(1);\n}\n\n.circle .icon {\n  text-decoration: none;\n  display: block;\n  //height: 40px;\n  //width: 40px;\n  position: absolute;\n  text-align: center;\n  cursor: pointer;\n  background-color: white;\n  transition: .3s;\n}\n\n.circle a:hover {\n  color: #eef;\n}\n\n.menu-button {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  text-decoration: none;\n  text-align: center;\n  color: #444;\n  border-radius: 50%;\n  display: block;\n  height: 60px;\n  width: 60px;\n  line-height: 50px;\n  padding: 10px;\n  background: white;\n  transition: .3s;\n}\n\n.menu-button:hover {\n  background-color: #70B1B1;\n}\n\n.edit {\n  &:hover {\n    background-color: #71A647;\n  }\n}\n\n.questionMask {\n  &:hover {\n    background-color: #747CBE;\n  }\n}\n\n.topButton {\n  color: black;\n  font-size: 14px;\n  font-weight: 500;\n  width: 120px;\n  height: 32px;\n  border-radius: 8px;\n  background-color: #f3f4f5;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 12px;\n}\n\n.active {\n  color: white;\n}\n\n.tutorialButtonActive {\n  background-color: @button-green-color;\n}\n\n.otherButtonActive {\n  background-color: @button-blue-color;\n}\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
